import { HRRAExceptionCode } from "@hrra/common-models";
import { createSelector } from '@ngrx/store';
import { JobseekerBlacklistUpdateViewModel } from 'src/app/jobseeker/shared/services/jobseeker-settings.service';
import { selectJobseekerStoreState } from '../jobseeker-profile/selectors';

export const selectJobseekerPrivacyList = createSelector(
    selectJobseekerStoreState,
    s => s.jobseekerLookup.lookup?.jobseekerPrivacyList
);

export const selectSelectedJobseekerPrivacy = createSelector(
    selectJobseekerStoreState,
    s => s.jobseekerSettings.selectedPrivacy
);

export const selectJobseekerCurrentPasswordIsIncorrect = createSelector(
  selectJobseekerStoreState,
  (e) => { return e.jobseekerSettings.jobseekerChangePasswordFailureDetails?.errorCode == HRRAExceptionCode.JobseekerCurrentPasswordIsIncorrect;
  }
);

export const selectCurrentPasswordIsIncorrect = createSelector(
  selectJobseekerStoreState,
  (e) =>  e?.jobseekerSettings?.updateEmailFailureDetails?.errorCode == HRRAExceptionCode.CurrentPasswordIsIncorrect
);

export const selectIsOTPCodeNotValid = createSelector(
  selectJobseekerStoreState,
  (e) => e?.jobseekerSettings?.updateUserEmailFailureDetails?.errorCode == HRRAExceptionCode.OTPCodeNotValid
);

export const selectIsOTPCodeExpired = createSelector(
  selectJobseekerStoreState,
  (e) => e?.jobseekerSettings?.updateUserEmailFailureDetails?.errorCode == HRRAExceptionCode.OTPCodeExpired
);

export const selectIsUpdateUserEmailSuccess = createSelector(
  selectJobseekerStoreState,
  (e) => e.jobseekerSettings.updateUserEmailSuccess
);

export const selectJobseekerPasswordMismatch = createSelector(
    selectJobseekerStoreState,  
    (e) => { 
        return e.jobseekerSettings.jobseekerChangePasswordFailureDetails?.errorCode == HRRAExceptionCode.PasswordMismatch;
    }
);

export const selectJobseekerIgnoredCustomerList = createSelector(
    selectJobseekerStoreState,
    e => e.jobseekerSettings.blacklist.jobseekerIgnoredCustomerCurrentList
);

export const selectCustomerList = createSelector(
    selectJobseekerStoreState,
    e => e.jobseekerSettings.blacklist.jobseekerCustomerCurrentList
);

export const searchedCustomerList = (searchValue: string = "") => createSelector(
    selectCustomerList,
    e => e.filter(e => e.name.toLowerCase().includes(searchValue.toLowerCase()))
);

export const selectCurrentBlacklist = createSelector(
    selectJobseekerStoreState,
    (e) => {
        let result: JobseekerBlacklistUpdateViewModel = <any>{};
        result.ignoredCustomerList = e.jobseekerSettings.blacklist.jobseekerIgnoredCustomerCurrentList?.map(e => e.value);

        return result;
    }
);

export const selectIsPasswordChangeActive = createSelector(
    selectJobseekerStoreState,
    (state) => state.jobseekerSettings.isPasswordChangeActive
);

export const selectIsEmailChangeActive = createSelector(
    selectJobseekerStoreState,
    (state) => state.jobseekerSettings.isEmailChangeActive
);

export const selectIsJobseekerSettingsLoading = createSelector(
    selectJobseekerStoreState,
    e => e.jobseekerSettings.loadingPrivacy || e.jobseekerSettings.blacklist.loadJobseekerBlacklist || e.jobseekerSettings.updateEmailLoading || e.jobseekerSettings.verificationCodeLoading
);

export const selectIsJobseekerUpdateEmailLoading = createSelector(
    selectJobseekerStoreState,
    e => e.jobseekerSettings.updateEmailLoading
);

export const selectVerificationTimer = createSelector(
  selectJobseekerStoreState,
  (state) => state.jobseekerSettings.verificationTimer
);

export const selectIsTimerActive = createSelector(
  selectJobseekerStoreState,
  (state) => state.jobseekerSettings.isTimerActive
);

export const selectRequestVerificationCodeLoading = createSelector(
    selectJobseekerStoreState,
    e => e.jobseekerSettings.verificationCodeLoading || e.jobseekerSettings.updateLoading
);


export const selectIsJobseekerSettingUpdating = createSelector(
    selectJobseekerStoreState,
    e => e.jobseekerSettings.updateLoading
);

export const selectRequestId = createSelector(
    selectJobseekerStoreState,
    (state) => state.jobseekerSettings.requestId
);

export const selectNextAllowedDate = createSelector(
    selectJobseekerStoreState,
    (state) => state.jobseekerSettings.nextRequestAllowedDate
);

export const selectResendCooldownSeconds = createSelector(
    selectNextAllowedDate,
    (date) => {
        if (!date) return 0;
        // Force UTC parsing in case the backend omits the trailing Z / offset.
        const normalized = /[Zz]|[+-]\d{2}:?\d{2}$/.test(date) ? date : date + 'Z';
        const remainingMs = new Date(normalized).getTime() - Date.now();
        return Math.max(0, Math.ceil(remainingMs / 1000));
    }
);